import { useEffect, useRef, useState } from "react";
import "./ToolBar.css";
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { STORAGE_KEY } from "../utils/Constant";
import {
  setLocalLogout,
} from "../redux/slices/loginSlice";
import { getFromLocalStorage } from "../utils/Util";
import { userManager } from "../utils/AuthConfig";
import Notification from "../assets/img/Notification.svg";
import PowerSettings from "../assets/img/PowerSettings.svg";
import Settings from "../assets/img/Settings.svg";
import Tooltip from "../assets/img/Tooltip.svg";

const ToolBar = ({title, tabOptions, className}: any) => {
  const [isProfileSecOpen, setIsProfileSecOpen] = useState(false);

  const profileSecRef = useRef(null);
  const profileNameRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const authData: any = JSON.parse(getFromLocalStorage(STORAGE_KEY.AUTH_DATA));
  const userEmail = authData?.emailId;
  const userName = authData?.employeeName
    ? authData?.employeeName.split(":")[0]
    : "";

  const getInitials = (fullName: string): string => {
    if (!fullName) return "";
    const names = fullName.trim().split(" ");
    if (names.length < 2) return names[0].charAt(0).toUpperCase();
    return (
      names[0].charAt(0) + names[names.length - 1].charAt(0)
    ).toUpperCase();
  };

  const handleToggleProfile = () => {
    setIsProfileSecOpen((prev) => !prev);
  };

  const callLogout = () => {
    dispatch(setLocalLogout({}));
    userManager
      .signoutRedirect()
      .then(() => {
        // console.log("Logout initiated", response);
        toast.success("Logged Out Successfully!");
      })
      .catch((error) => {
        console.error("Logout error:", error);
      });
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        profileSecRef.current &&
        !(profileSecRef.current as HTMLDivElement).contains(
          event.target as Node
        ) &&
        profileNameRef.current &&
        !profileNameRef.current.contains(event.target as Node)
      ) {
        setIsProfileSecOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const username = getInitials(userName);

  return (
    <div className={`header-sec ${className}`}>
      <div className="d-flex align-items-center justify-content-between header-border">
        <div className="module-name">{title}</div>
        <div className="d-flex align-items-center gap-3 pt-4 pb-3">
          <div
            className="profile-icon"
            onClick={handleToggleProfile}
            ref={profileNameRef}
          >
            {username}
          </div>
          {isProfileSecOpen && (
            <div className="profile-sec" ref={profileSecRef}>
              <img src={Tooltip} alt="Tooltip" className="profile-tooltip" />

              <div style={{minWidth:'300px'}}>
                <div className="d-flex justify-content-between" style={{fontSize: '13px'}}>
                  <p>Kshema General Insurance Limited</p>
                </div>

                <div className="profile-details">
                  <div className="profile-name" style={{fontSize: '30px', padding: '40px'}}>
                      {username}
                  </div>
                  <div className="d-flex flex-column justify-content-between">
                    <span className="profile-values">{authData.employeeName}</span>
                    <span className="profile-values">{authData.emailId}</span>
                    <span className="profile-values">{authData.roleName?.join(', ')}</span>
                  </div>
                </div>

                <div className="logout-sec" onClick={callLogout}>
                  <img src={PowerSettings} alt="Logout Icon" />
                  <span className="profile-headings">Logout</span>
                </div> 
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ToolBar;
